import axios from "axios";
import config from '../../config'
// const BASE_URL = "http://3.22.188.65:8080"
const BASE_URL = config.apiUrl


const GetlisteAnimaux = async () =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }

    const instance = axios.create(options)
      try {
        const response = await instance.get("/rabat-zoo/animal/api/all" );
        return response.data;
      } catch (error) {
          throw error.response
      }
}

const GetlisteAnimauxVivarium = async () =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }

    const instance = axios.create(options)
      try {
        const response = await instance.get("/rabat-zoo/animal/api/VivaruimAll" );
        return response.data;
      } catch (error) {
          throw error.response
      }
}

const AddAnimaux = async (DataPost) =>{

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }

    const instance = axios.create(options)

      try {
        const response = await instance.post("/rabat-zoo/animal/api/add",DataPost );
        return response;
      } catch (error) {
          throw error.response
      }
}

const updateAnimaux = async (DataPost) =>{

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }

    const instance = axios.create(options)

      try {
        const response = await instance.put("/rabat-zoo/animal/api/update",DataPost );
        return response;
      } catch (error) {
          throw error.response
      }
}

const disableAnimaux = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }

    const instance = axios.create(options)

      try {
        const response = await instance.get("/rabat-zoo/animal/api/disable/" + id );
        return response;
      } catch (error) {
          throw error.response
      }
}

const removeAnimaux = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }

    const instance = axios.create(options)

      try {
        const response = await instance.get("/rabat-zoo/animal/api/remove/" + id );
        return response;
      } catch (error) {
          throw error.response
      }
}

const enableAnimaux = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }

    const instance = axios.create(options)

      try {
        const response = await instance.get("/rabat-zoo/animal/api/enable/" + id );
        return response;
      } catch (error) {
          throw error.response
      }
}

const UploadFileAnimaux = async (formData) =>{

    const options = {
        baseURL: BASE_URL,
        headers: {
            'Content-Type': 'multipart/form-data',
          },
    }

    const instance = axios.create(options)
      try {
        const response = await instance.post("/rabat-zoo/animal/api/upload",formData );
        return response.data;
      } catch (error) {
          throw error.response
      }
  }




export {GetlisteAnimaux,AddAnimaux,UploadFileAnimaux,updateAnimaux, disableAnimaux, enableAnimaux,GetlisteAnimauxVivarium,removeAnimaux}
